export const useConvertedLink = (element = null, item = {}) => {
    let link = item.url;

    if (element) {
        const localePath = useLocalePath();
        const converted = {
            "homeConsultancy": {
                name: "index"
            },
            "homeDevelopment": {
                name: "index"
            },
            "homeGroup": {
                name: "index"
            },

            "consultancy": {
                name: "slug",
                params: {
                    slug: element.slug
                }
            },
            "development": {
                name: "slug",
                params: {
                    slug: element.slug
                }
            },
            "group": {
                name: "slug",
                params: {
                    slug: element.slug
                }
            },
            "news": {
                name: "news-slug",
                params: {
                    slug: element.slug
                }
            },
            "projects": {
                name: "projects-slug",
                params: {
                    slug: element.slug
                }
            },
            "solutions": {
                name: "solutions-slug",
                params: {
                    slug: element.slug
                }
            },
            "vacancies": {
                name: "vacancies-slug",
                params: {
                    slug: element.slug
                }
            },
        }

        
        link = localePath(converted[element.sectionHandle]);
    }

    return link;
}